module.exports = __webpack_public_path__ + "static/media/dashboard.bf394bbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard.svg
// module id = 916
// module chunks = 0